module.exports = __webpack_public_path__ + "img/Vietnam-5-hover.ccde667c.jpg";